<script setup lang="ts">
import { computed } from 'vue'
import BasicSpinnerDefault from './BasicSpinner.default.vue'
import BasicSpinnerFlipnovel from './BasicSpinner.flipnovel.vue'
import { brand } from '@/config/brands'
import { loadBrandComponent } from '@/utils/loadBrandConfig'

const isFlipnovelFamily = ['flipnovel', 'storlyn', 'moonpage', 'novaris'].includes(brand)
const spinnerSize = computed(() => isFlipnovelFamily ? '32px' : '40px')

const SpinnerComponent = loadBrandComponent({
  rocnovel: BasicSpinnerDefault,
  oceread: BasicSpinnerDefault,
  ficmoon: BasicSpinnerDefault,
  novelarc: BasicSpinnerDefault,
  storyella: BasicSpinnerDefault,
  silktale: BasicSpinnerDefault,
  pearla: BasicSpinnerDefault,
  fictora: BasicSpinnerDefault,
  marinovel: BasicSpinnerDefault,
  flipnovel: BasicSpinnerFlipnovel,
  novaris: BasicSpinnerFlipnovel,
})
</script>

<template>
  <div class="spinner" :style="{ width: spinnerSize, height: spinnerSize }">
    <component :is="SpinnerComponent" />
  </div>
</template>

<style scoped>
.spinner {
  display: inline-block;
}
</style>
